import * as React from 'react';

import styles from './styles.module.scss';

interface Props {
	jobCode: string;
	title: string;
	customerCompany: Nullable<string>;
	isInternal: boolean;
}

const JobOption: React.FC<Props> = ({
	jobCode,
	title,
	customerCompany,
	isInternal,
}) => {

	return (
		<div className={styles.jobOption}>
			<div className={styles.jobOptionLabel}>
				{jobCode} | {title}
			</div>
			<div className={styles.jobOptionSubtitle}>
				{
					isInternal
						? <div className={styles.internalIndicator}>I</div>
						: null
				}
				{customerCompany}
			</div>
		</div>
	);
};

export default React.memo(JobOption);
